import CoreSearch from './CoreSearch';

export { type CoreSearchProps } from './CoreSearch';
export default CoreSearch;
